import * as immutable from 'object-path-immutable'
import { pluck } from '../util/pluck'

export function toggleTopic (state, topic, defaultValue={}) {
  const isOn = pluck(state, [topic.id]);
  if (isOn) {
    return immutable.del(state, [topic.id]);
  } else {
    return immutable.set(state, [topic.id], defaultValue);
  }
}

export function setActiveView (state, topic, section, view) {
  return immutable.set(state, [topic.id, 'sections', section.uuid, 'activeViewId'], view.id || view.title);
}

export function getActiveView (state, topic, section) {
  const id = pluck(state, [topic.id, 'sections', section.uuid, 'activeViewId']);

  if (id) {
    const views = section.notebookViews;
    const idx = views.findIndex(v => v.id === id);
    if (idx !== -1) {
      return {
        view: views[idx],
        idx
      }
    }
  }

  const view = section.notebookViews[0];
  return {
    view,
    idx: 0
  };
}

export function viewsForSections (state) {
  const data = Object.values(state)
    .map(t => t && t.sections || {})
    .map(ss => {
      return Object.entries(ss)
        .map(([id, v]) => {
          if (v && v.activeViewId) {
            return [id, v.activeViewId]
          }

          return null;
        }).filter(e => !!e);
    }).reduce((acc, ids) => acc.concat(ids), []);

  return new Map(data);
}
